export function isDropboxUrl(url: URL) {
  return url.host === 'www.dropbox.com'
}

export function buildStreamUrlFromDropboxUrl(url: URL): URL {
  const modifiedUrl = new URL(url.toString())
  modifiedUrl.host = 'dl.dropboxusercontent.com'
  return modifiedUrl
}